export const PASS_SELECT = [{
  value: 2,
  label: '通过'
}, {
  value: 3,
  label: '拒绝'
}]
export const MLIST_SELECT = [
  {
    value: 1,
    label: '渠道名称'
  }, {
    value: 2,
    label: '会员姓名'
  }, {
    value: 3,
    label: '手机号码'
  }, {
    value: 4,
    label: '身份证号'
  }
]
export const AUDIT_SELECT = [
  {
    value: 1,
    label: '客户姓名'
  }, {
    value: 2,
    label: '手机号码'
  }, {
    value: 3,
    label: '身份证号'
  }
]
export const AUDIT_SELECT_LESS = [
  {
    value: 1,
    label: '客户姓名'
  }, {
    value: 2,
    label: '手机号码'
  }
]
export const CUSTOMER_SELECT = [{
  value: 1,
  label: '新客户'
}, {
  value: 2,
  label: '老客户'
}]
export const TIME_SELECT = [{
  value: 1,
  label: '申请时间'
}, {
  value: 2,
  label: '审核时间'
}, {
  value: 3,
  label: '放款时间'
}, {
  value: 4,
  label: '约定还款日'
}]

export const TIME_SELECT_LESS = [{
  value: 1,
  label: '申请时间'
}, {
  value: 2,
  label: '审核时间'
}, {
  value: 3,
  label: '放款时间'
}]

export const LOAN_TYPE = [{
  value: 1,
  label: '延期'
}, {
  value: 2,
  label: '逾期'
}]

export const LOAN_MODE = [{
  value: 0,
  label: '支付宝'
}, {
  value: 1,
  label: '微信支付'
}, {
  value: 2,
  label: '银联支付'
}, {
  value: 3,
  label: '线下支付宝'
}, {
  value: 4,
  label: '线下微信支付'
}]

export const ALLOT_TYPE = [{
  value: 0,
  label: '已分配'
}, {
  value: 1,
  label: '未分配'
}]
export const STATE_TYPE = [{
  value: 0,
  label: '禁用'
}, {
  value: 1,
  label: '启用'
}]

export const PROMOTION_TYPE = ['cpa', 'cps', 'uv']

export const REPAYMENT_TYPE = [{
  value: 3,
  label: '线下支付宝'
}, {
  value: 4,
  label: '线下微信'
}]
